module.exports = __webpack_public_path__ + "img/Switch.f28b3e09.svg";